export const Messages = {
    SITE_COPIED: 'Copied.<br /><br />You can paste this into any site (⌘V)',
}